import React, { useCallback } from 'react'
import { EmtButton, EmtIcon, EmtTypography } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import { styled } from '@mui/material/styles'
import { ButtonProps } from '@mui/material/Button'
import Box from '@mui/material/Box'
import { gtmSendCustomEvent } from '@/helpers/GTMHelper'
import { Constants } from '@/assets'
import { useIsQueryOwner } from '@/hooks'
import useCurrentUser from '@/hooks/useCurrentUser'

type Props = ButtonProps & {
  count?: number
  compact?: boolean
}

const StyledFiltersButton: any = styled(EmtButton)(({ theme }) => ({
  fontSize: '12px',
  '&.compact-variant': {
    padding: '7px',
    '&.MuiButtonBase-root': {
      flexDirection: 'column',
      '& .MuiButton-startIcon': {
        margin: '0',
      },
    },
  },
  '& .notification': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: '100%',
    width: 20,
    height: 20,
    position: 'absolute',
    right: -8,
    top: -8,
  },
  '& .emt-icons': {
    fontSize: '18px !important',
  },
}))

const FiltersButton: React.FC<Props> = (props) => {
  const { t } = useTranslation('search')
  const { count, compact, className, onClick, ...rest } = props
  const [isQueryOwner] = useIsQueryOwner()
  const { currentUser } = useCurrentUser()

  const handleClick = useCallback((e) => {
    gtmSendCustomEvent('member_open_filters', {
      member_role_variable: isQueryOwner ? 'maitre' : 'emprunteur',
      member_id_variable: currentUser?.id || '',
      brand_variable: Constants.storageID,
      website_variable: Constants.rootUrl,
    })
    onClick && onClick(e)
  }, [])
  return (
    <StyledFiltersButton
      color="primary"
      variant="whiteOutlined"
      startIcon={<EmtIcon className={compact ? 'emt-adjust-horizontal' : 'emt-adjust-horizontal-1'} />}
      className={compact ? `compact-variant ${className}` : className}
      onClick={handleClick}
      {...rest}
    >
      <EmtTypography variant="body2">{t('filters.title')}</EmtTypography>
      {count ? (
        <Box className="notification">
          <EmtTypography variant="caption">{count}</EmtTypography>
        </Box>
      ) : null}
    </StyledFiltersButton>
  )
}

export default FiltersButton
